var render = function render(){var _vm=this,_c=_vm._self._c;return _c('common-container',{staticClass:"bottom-one",attrs:{"title":"报警趋势"}},[_c('LineCharts',{attrs:{"id":"bjqs","lists":_vm.datas,"areaColor":_vm.areaColor,"colors":_vm.colors}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }